import { useQuery } from '@tanstack/react-query';
import {
  getVettingApplicationById,
  normalizeVettingApplicationDetailResponse,
} from '../services/vettingApplications';
import { vettingApplicationQueryKeys } from './query-keys';

export const useVettingApplicationDetailQuery = (applicationId, options = {}) => {
  const { enabled = true } = options;

  return useQuery({
    queryKey: vettingApplicationQueryKeys.detail(applicationId),
    enabled: Boolean(applicationId) && enabled,
    queryFn: async () => {
      const result = await getVettingApplicationById(applicationId);
      if (!result.success) {
        throw new Error(result.message || 'Failed to fetch vetting application detail');
      }
      return normalizeVettingApplicationDetailResponse(result.data);
    },
    ...options,
  });
};
